export const copyUrl = () => {
  return navigator.clipboard.writeText(window.location.href)
}
